import { Navigate, Route } from "react-router-dom";
import ReservationDetail from "../components/Form/ReservationDetail";
import LpPage from "./LpPage";
import TopPage from "./TopPage";

class Page {
  readonly path: string;
  readonly element: JSX.Element;

  constructor(path: string, element: JSX.Element) {
    this.path = path;
    this.element = element;
  }

  get Route() {
    return <Route element={this.element} key={`r:${this.path}`} path={this.path} />;
  }
  get NavigateRoute() {
    return <Route element={<Navigate replace to={this.path} />} key={`n:${this.path}`} path={"*"} />;
  }
}

export default class Pages {
  static readonly AllPages = {
    detail: new Page("detail/*", <ReservationDetail />),
    lp: new Page("lp/*", <LpPage />),
    top: new Page("", <TopPage />),
  };

  static GetRoutes() {
    const pages = Object.values(Pages.AllPages).map((p, i) => p.Route);
    return [...pages, Pages.AllPages.top.NavigateRoute];
  }
}
